<template>
  <div
    :class="{hidden: state.hidden}"
    class="navigation"
  >
    <div
      class="main_container"
    >
      <router-link
        :to="{ name: 'Home'}"
        class="navLink"
        :class="{selected: route.meta.navigationTab === 'home', active: route.meta.navigationTab === 'home'}"
      >
        <HeaderHomeIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'home' ? selectedColor : defaultColor"
        />
        {{ bb('BottomNavigation.Home') }}
      </router-link>

      <router-link
        :to="{ name: 'TrainingsList' }"
        class="navLink"
        :class="{selected: route.meta.navigationTab === 'trainings-list', active: route.meta.navigationTab === 'trainings-list'}"
      >
        <HeaderTrainingsIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'trainings-list' ? selectedColor : defaultColor"
        />
        {{ bb('BottomNavigation.Trainings') }}
      </router-link>

      <router-link
        :to="{ name: 'ChatList' }"
        class="navLink"
        :class="{ selected: route.meta.navigationTab === 'chat', active: route.meta.navigationTab === 'chat' }"
      >
        <HeaderChatIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'chat' ? selectedColor : defaultColor"
          :lock="!isSubscriptionActive"
        />
        {{ bb('BottomNavigation.Chat') }}
      </router-link>

      <router-link
        :to="{ name: 'Profile' }"
        class="navLink"
        :class="{selected: route.meta.navigationTab === 'profile', active: route.meta.navigationTab === 'profile'}"
      >
        <HeaderProfileIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'profile' ? selectedColor : defaultColor"
        />
        {{ bb('BottomNavigation.Profile') }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, reactive } from 'vue'
import { useRoute } from 'vue-router'

import store from '@/store/store'
import { bb } from '@/locales/i18nextInit.js'

import HeaderChatIcon from './BottomAppBarChatIcon.vue'
import HeaderHomeIcon from './BottomAppBarHomeIcon.vue'
import HeaderProfileIcon from './BottomAppBarProfileIcon.vue'
import HeaderTrainingsIcon from './BottomAppBarTrainingsIcon.vue'

const route = useRoute()

const state = reactive({
  hidden: false
})

const isSubscriptionActive = computed(() => store.getters['user/isSubscriptionActive'])

// Исходная высота экрана
let initialScreenHeight = 0;

const theme = store.state.app.appData?.themes?.find(theme => theme.default)

const selectedColor = theme?.styles.app['bar-icon-active-color'] ?? '#FFFFFF'
const defaultColor = theme?.styles.app['bar-icon-color'] ?? '#8B8B8B'

// Функция для проверки состояния клавиатуры
function checkKeyboardState() {
  const currentVisualHeight = window.visualViewport?.height || window.innerHeight;

  if (currentVisualHeight < initialScreenHeight) {
    state.hidden = true; // Клавиатура открыта
  } else {
    state.hidden = false; // Клавиатура закрыта
  }
}

function onFocus(e) {
  const tags = ['INPUT', 'TEXTAREA']
  const focused = e.target

  if (!focused) {
    return
  }

  if (tags.includes(focused.tagName)) {
    state.hidden = true
  }
}

function onBlur() {
  state.hidden = false
}

onMounted(() => {
  // Сохраняем исходную высоту экрана
  initialScreenHeight = window.visualViewport?.height || window.innerHeight;

  // Добавляем обработчики событий
  if (!store.state.user.profile.onboarding_finished) {
    state.hidden = true
    return
  }

  window.visualViewport.addEventListener('resize', checkKeyboardState);
  addEventListener('focus', onFocus, true);
  addEventListener('blur', onBlur, true);
});

onUnmounted(() => {
  // Удаляем обработчики событий
  window.visualViewport.removeEventListener('resize', checkKeyboardState);
  removeEventListener('focus', onFocus);
  removeEventListener('blur', onBlur);
});

</script>

<style lang="scss">
@import "@/assets/variables";

.navigation {
  border-top: 1px solid var(--app-bar-border-color);
  background: var(--app-bar-color);
  display: flex;
  height: $bottomMenuOffset;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 99;
  flex-shrink: 0;

  .main_container {
    display: flex;
    padding: 12px 0 24px 0;

    & > .navLink {
      flex-basis: 100px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 10px;
      font-weight: 600;
      gap: 6px;
      color: var(--app-bar-icon-color, #8B8B8B);

      &.selected {
        color: var(--app-bar-icon-active-color);
      }
    }
  }
}
</style>
